/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_ARCHIVED_POLICY: {
    size: 10,
    skip: 0,
    where: [],
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.archivedPolicy.archivedPolicy',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_ARCHIVED_POLICY' },
      },
    },
    GET_ARCHIVED_POLICY: {
      invoke: {
        id: 'archivedPolicy',
        src: 'archivedPolicy',
        onDone: {
          target: 'RENDER_ARCHIVED_POLICY',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_ARCHIVED_POLICY_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_ARCHIVED_POLICY: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_ARCHIVED_POLICY',
        },
      },
    },
    RENDER_ARCHIVED_POLICY_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
